import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';

const BillingCancel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#000000]">
      <div className="section-card max-w-md w-full text-center">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 rounded-full bg-orange-500/20 flex items-center justify-center">
            <XCircle className="w-10 h-10 text-orange-400" />
          </div>
        </div>

        <h1 className="text-2xl font-bold text-[#F5F5F7] mb-3">
          Checkout Cancelled
        </h1>
        <p className="text-[#86868B] mb-6">
          Your subscription upgrade was cancelled. No charges were made to your account.
        </p>

        <div className="space-y-3">
          <button
            onClick={() => navigate('/billing')}
            className="w-full btn-t btn-t-primary flex items-center justify-center gap-2"
          >
            <RefreshCw className="w-4 h-4" />
            Try Again
          </button>
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full btn-t flex items-center justify-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Dashboard
          </button>
        </div>

        <div className="mt-8 p-4 bg-[#1C1C1E] rounded-lg border border-[#2C2C2E]">
          <p className="text-sm text-[#86868B]">
            Need help choosing a plan? <br />
            <button
              onClick={() => navigate('/settings')}
              className="text-blue-400 hover:underline mt-1"
            >
              Contact support
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default BillingCancel;
